export default __webpack_public_path__ + "static/media/back-blue.0b7022cc.svg";